import * as React from 'react';

import _t from 'i18n!nls/discussions';

type Props = {
  post: $TSFixMe;
};

const EditIndicator: React.FC<Props> = ({ post }) => {
  if (!post.state.edited) return null;

  return (
    <span className="rc-EditIndicator">
      <span aria-hidden={true}>&nbsp;·&nbsp;</span>
      {post.state.edited.userId !== post.creator?.userId ? _t('Edited by moderator') : _t('Edited')}
    </span>
  );
};

export default EditIndicator;
